import { map } from 'jquery'

export default class collectDialogCtrl {
  constructor(
    $scope,
    $uibModalInstance,
    httpRequest,
    logger,
    items1,
    sweetalert
  ) {
    $scope.cancel = function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    $scope.ok = function ok() {
      $scope.selectedRows = items1
      const selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let declareIdArr = selectedRowIdList.map(String)
      httpRequest.post_getRpaGsTaskManualDeclare(declareIdArr).then((res) => {
        logger.logSuccess(res.data.value)
      })
      $uibModalInstance.close()
    }
  }
}
collectDialogCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'httpRequest',
  'logger',
  'items1',
  'sweetalert',
]



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/declarationTaskTracking/collectDialogCtrl.js